import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { closest } from '../../../core/util/closest';

@Component({
    selector: 'control-messages',
    template: `
        <ion-item *ngIf="errorMessage && ionItem">
            <div>{{errorMessage}}</div>
        </ion-item>
        <div *ngIf="errorMessage && !ionItem">{{errorMessage}}</div>
    `
})
export class ControlMessagesComponent {
    @Input() control: AbstractControl;
    @Input() ionItem = true;

    constructor(
        protected elemRef: ElementRef,
        protected translateService: TranslateService
    ) {

    }

    ngOnInit(): void {
        if (this.ionItem) {
            return;
        }

        const wrapper = closest(this.elemRef.nativeElement, '.input-wrapper');
        if (!wrapper) {
            return;
        }
        wrapper.classList.add('has-control-messages');
    }

    @HostBinding('class.ion-item-child')
    get isChildNonOwnIonItem(): boolean {
        return !this.ionItem;
    }

    get errorMessage(): string {

        if (!this.control) {
            console.error('no control was passed in');
            return;
        }

        if (this.control.valid) {
            return '';
        } else if (!this.control.errors) {
            return '';
        } else if (!this.control.dirty && this.control.untouched) {
            return '';
        }

        const errorKey = Object.keys(this.control.errors).pop();

        if (!errorKey) {
            return '';
        }

        const errorMessageArgs = this.control.errors[errorKey] || {};

        return this.translateService.instant(`validator.${errorKey}`, errorMessageArgs);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/control-message/control-messages.ts